"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavWrapper = exports.MainBarContents = exports.MainBar = exports.Container = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreAnimate = require("@vfuk/core-animate");

var _coreMixins = require("@vfuk/core-mixins");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MainBar = _styledComponents["default"].header.withConfig({
  displayName: "MainBarstyle__MainBar",
  componentId: "sc-3plkqm-0"
})(function (props) {
  return (0, _styledComponents.css)(["background-color:", ";", ";", ";overflow:hidden;position:sticky;top:0;left:0;width:100%;z-index:", ";"], props.topNavigationTheme.appearance[props.appearance].mainBar.backgroundColor, (0, _coreMixins.advancedSpacing)('padding', [3, 0]), (0, _coreMixins.elevation)(true), props.zIndex + 1);
});

exports.MainBar = MainBar;

var Container = _styledComponents["default"].div.withConfig({
  displayName: "MainBarstyle__Container",
  componentId: "sc-3plkqm-1"
})(function (props) {
  return (0, _styledComponents.css)(["width:100%;max-width:", "px;margin:0 auto;"], props.theme.gridConfig.springWidth);
});

exports.Container = Container;

var NavWrapper = _styledComponents["default"].div.withConfig({
  displayName: "MainBarstyle__NavWrapper",
  componentId: "sc-3plkqm-2"
})(function () {
  return (0, _styledComponents.css)(["position:relative;display:flex;align-items:center;height:44px;", " ", "{flex-grow:1;}"], _coreMixins.respondTo.md((0, _styledComponents.css)(["height:46px;"])), _coreAnimate.AnimateStyles.Animate);
});

exports.NavWrapper = NavWrapper;

var MainBarContents = _styledComponents["default"].nav.withConfig({
  displayName: "MainBarstyle__MainBarContents",
  componentId: "sc-3plkqm-3"
})(function () {
  return (0, _styledComponents.css)(["width:100%;display:flex;align-items:center;justify-content:space-between;"]);
});

exports.MainBarContents = MainBarContents;
//# sourceMappingURL=MainBar.style.js.map